// @ai-generated 2026-09-17T10:27:43+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import * as AgenticOrchestrator from '@Modules/AgenticOrchestrator';
import { RouteObject } from 'react-router';

/** The agent chat, with the conversation in the route so a link to one can be shared. */
export function setupChatRouting(): RouteObject {
    return {
        path: 'chat',
        children: [
            {
                path: '',
                element: <AgenticOrchestrator.FrameAgentChat />,
            },
            {
                path: ':threadId',
                element: <AgenticOrchestrator.FrameAgentChat />,
            },
        ],
    };
}
